"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _differenceInCalendarDays = _interopRequireDefault(require("date-fns/differenceInCalendarDays"));
var _getDay = _interopRequireDefault(require("date-fns/getDay"));
var _isToday = _interopRequireDefault(require("date-fns/isToday"));
var _getNextDay = _interopRequireDefault(require("../date/getNextDay"));
var _getNextWorkingDay = _interopRequireDefault(require("../date/getNextWorkingDay"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * get next available date from the selected date
 * @param {Date} pickUpDate - e.g: Wed Mar 29 2023 12:00:00 GMT+0300 (Arabian Standard Time)
 * @param {Date} dropOffDate - e.g: Thu Mar 30 2023 12:00:00 GMT+0300 (Arabian Standard Time)
 * @param {Array} pickUpOffDays - e.g: [1,4,5]
 * @param {Array} dropOffDays - e.g: [1,2,5]
 * @param {Boolean} isTodayDisabled
 * @returns {Object} nextPickUpWorkingDay, nextDropOffWorkingDay, isPickUpDateChanged, isDropOffDateChanged}
 */
function getNextAvailableDate(pickUpDate, dropOffDate, pickUpOffDays, dropOffDays, isTodayDisabled) {
  var startDay = pickUpDate;
  var diffInDays = (0, _differenceInCalendarDays["default"])(dropOffDate, pickUpDate);

  // If Pickup Date is not available
  var isTodayDate = (0, _isToday["default"])(startDay);
  var dayKey = (0, _getDay["default"])(startDay);
  var isOffDay = pickUpOffDays.indexOf(dayKey) !== -1;
  if (isOffDay || isTodayDate && isTodayDisabled) {
    if (isTodayDate && isTodayDisabled) {
      startDay = (0, _getNextDay["default"])(startDay);
    }
    var nextPickUpWorkingDay = (0, _getNextWorkingDay["default"])(startDay, pickUpOffDays);

    // get available DropOff date
    var nextDropOffDays = (0, _getNextDay["default"])(nextPickUpWorkingDay, diffInDays);
    var nextDropOffWorkingDay = (0, _getNextWorkingDay["default"])(nextDropOffDays, dropOffDays);
    return {
      nextPickUpWorkingDay: nextPickUpWorkingDay,
      nextDropOffWorkingDay: nextDropOffWorkingDay,
      isPickUpDateChanged: true,
      isDropOffDateChanged: true
    };
  }

  // get available DropOff Date
  startDay = dropOffDate;
  dayKey = (0, _getDay["default"])(startDay);
  isOffDay = dropOffDays.indexOf(dayKey) !== -1;
  if (isOffDay) {
    var nextDay = (0, _getNextDay["default"])(pickUpDate, diffInDays);
    var _nextDropOffWorkingDay = (0, _getNextWorkingDay["default"])(nextDay, dropOffDays);
    return {
      nextPickUpWorkingDay: pickUpDate,
      nextDropOffWorkingDay: _nextDropOffWorkingDay,
      isPickUpDateChanged: false,
      isDropOffDateChanged: true
    };
  }

  // return selected date with no change
  return {
    nextPickUpWorkingDay: pickUpDate,
    nextDropOffWorkingDay: dropOffDate,
    isPickUpDateChanged: false,
    isDropOffDateChanged: false
  };
}
var _default = exports["default"] = getNextAvailableDate;